import { useEffect, useRef } from "react";
import './Camera.css';

const Camera = ({ closeApp }) => {

    const videoEle = useRef();

    const stopCamera = (e) => {
        if (e) { e.preventDefault(); }
        try {
            if (videoEle && videoEle.current && videoEle.current.srcObject) {
                const stream = videoEle.current.srcObject;
                const tracks = stream.getTracks();            
                tracks.forEach(track => {
                  track.stop();
                });
                videoEle.current.srcObject = null;
            }
        } catch(err) {
            console.log(err);
        }
    };
    const startCamera = async (e) => {
        e.preventDefault();
        try {
            const stream =  await navigator.mediaDevices.getUserMedia({
                video: true
            });

            videoEle.current.setAttribute('autoplay', '');
            videoEle.current.setAttribute('muted', '');
            videoEle.current.setAttribute('playsinline', '');

            videoEle.current.srcObject = stream;
            
        } catch(err) {
            console.log(err);
        }
    };

    useEffect(() => {
        
        //startCamera();

        return () => {
            stopCamera();
        };
    }, []);

    return (
        <div className="Camera">
            <div className="camera-button-wrap">
                <button onClick={startCamera}>Start</button><button onClick={stopCamera}>Stop</button><br />
            </div>
            
            <div className="app-open-controls app-open-controls-single">
                <div className="app-open-control-item"><button onClick={closeApp}>Close App</button></div>
            </div>
            
            <div className="camera-video-wrap">
                <video ref={videoEle} id="video" autoPlay></video>
            </div>
        </div>
    );
};
export default Camera;